import { render, staticRenderFns } from "./ToDo.vue?vue&type=template&id=2e78d0fc&scoped=true"
import script from "./ToDo.vue?vue&type=script&lang=js"
export * from "./ToDo.vue?vue&type=script&lang=js"
import style0 from "./tasks-page-new.scss?vue&type=style&index=0&id=2e78d0fc&prod&lang=scss&scoped=true&external"
import style1 from "./ToDo.vue?vue&type=style&index=1&id=2e78d0fc&prod&scoped=true&lang=scss"
import style2 from "./ToDo.vue?vue&type=style&index=2&id=2e78d0fc&prod&scoped=true&lang=css"
import style3 from "./ToDo.vue?vue&type=style&index=3&id=2e78d0fc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e78d0fc",
  null
  
)

export default component.exports